import { EshopHeaderContainer } from './containers';
import * as constants from './constants';
import * as actions from './actions';
import { reducer } from './reducer';
import { initialAction } from './initialAction';
const containers = { EshopHeaderContainer };
const eshopModule = { actions, containers, constants, reducer, initalAction: initialAction };
export default eshopModule;
